import { ClickAwayListener, Collapse, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { PlayerCharacterDisplay, WeaponDisplay as WD, Weapon, PlayerCharacter } from "../../model/character";
import SimpleTable from "../../components/SimpleTable";
import { ReactNode, useState } from "react";
import HeadingBar, { HeadingBarItem } from "../../components/HeadingBar";
import { StatDisplay } from "../../components/StatDisplay";
import CollapseClickAway from "../../components/CollapseClickAway";
import WeaponDetailDisplay from "../../components/displays/WeaponDetailDisplay";

import { ReactComponent as RangeIcon } from "../../components/icons/raw/Icon_Range.svg";
import { ReactComponent as EnduranceIcon } from "../../components/icons/raw/Icon_End_Damage.svg";
import { ReactComponent as CritDamageIcon } from "../../components/icons/raw/Icon_Crit_Damage.svg";
import { ReactComponent as MunitionsIcon } from "../../components/icons/raw/Icon_Munitions.svg";
import { ReactComponent as DiceIcon } from "../../components/icons/raw/Icon_Dice.svg";
import { ReactComponent as HitIcon } from "../../components/icons/raw/Icon_Hit.svg";
import Hexagon from "../../components/visual/Hexagon";

interface WeaponDisplayProps {
    character: PlayerCharacter;
    characterDisplay: PlayerCharacterDisplay;
    setCharacter: (character: PlayerCharacter) => void;
}

const WeaponRow = (props: {index: number, weapon: Weapon, display: WD, onClickMunitions: () => void}) => {
    const {index, display, weapon} = props;
    const [ show, setShow ] = useState(false);

    const details = <WeaponDetailDisplay weaponDisplay={display} weapon={weapon} />;

    return  <Grid container>
            <Grid item xs={11}>
                <Grid container>
                    <Grid item xs={7}><Typography fontWeight={700} fontSize={15}>{display.name}</Typography></Grid>
                    <Grid item xs={1}>{display.hitDice}<Typography fontSize={"0.75em"} display={"inline"}>d6</Typography></Grid>
                    <Grid item xs={1}>{StatDisplay(display.hitBonus + display.skillBonus)}</Grid>
                    <Grid item xs={1}>{display.range}</Grid>
                    <Grid item xs={1}>{StatDisplay(display.enduranceDamage)}</Grid>
                    <Grid item xs={1}>{display.critDamage}</Grid>
                    
                    <Grid item xs={12}><Typography variant="caption">
                        {display.features.length > 0 && <>Features: {display.features.join(", ")} - </>}
                        {display.weaponType.length > 0 && <>Type: {display.weaponType.join(", ")} - </>}
                        {display.variations.length > 0 && <>Variation {display.variations.join(", ")} - </>}
                        Draw {display.draw}, Reload {display.reload}, Slots: {display.slots}, Hands: {display.hands}, Acquire: {display.acquire}t, Resource: {display.resources}</Typography>
                        </Grid>
                    <Grid item xs={12}><Typography variant="caption"><Collapse in={show}>{display.description}</Collapse></Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={1}><Hexagon onClick={() => props.onClickMunitions()} name="" content={`${3-display.munitionsSpent}/3`}></Hexagon></Grid>
        </Grid>;

    // return <CollapseClickAway collapseContent={details}>
    //     <Grid container>
    //         <Grid item xs={11}>
    //             <Grid container>
    //                 <Grid item xs={7}><Typography fontWeight={700} fontSize={15}>{display.name}</Typography></Grid>
    //                 <Grid item xs={1}>{display.hitDice}<Typography fontSize={"0.75em"} display={"inline"}>d6</Typography></Grid>
    //                 <Grid item xs={1}>{StatDisplay(display.hitBonus + display.skillBonus)}</Grid>
    //                 <Grid item xs={1}>{display.range}</Grid>
    //                 <Grid item xs={1}>{StatDisplay(display.enduranceDamage)}</Grid>
    //                 <Grid item xs={1}>{display.critDamage}</Grid>
                    
    //                 <Grid item xs={12}><Typography variant="caption">
    //                     {display.features.length > 0 && <>Features: {display.features.join(", ")} - </>}
    //                     {display.weaponType.length > 0 && <>Type: {display.weaponType.join(", ")} - </>}
    //                     {display.variations.length > 0 && <>Variation {display.variations.join(", ")} - </>}
    //                     Draw {display.draw}, Reload {display.reload}, Slots: {display.slots}, Hands: {display.hands}, Acquire: {display.acquire}t, Resource: {display.resources}</Typography>
    //                     </Grid>
    //                 <Grid item xs={12}><Typography variant="caption"><Collapse in={show}>{display.description}</Collapse></Typography></Grid>
    //             </Grid>
    //         </Grid>
    //         <Grid item xs={1}><Hexagon name="" content={`${3-display.munitionsSpent}/3`}></Hexagon></Grid>
    //     </Grid>
    // </CollapseClickAway>
}

const WeaponDisplay = (props: WeaponDisplayProps) => {
    const { characterDisplay, character } = props;
    const theme = useTheme();

    const handleMunitions = (id: string) => {
        const weapon = character.weapons.find(cw => cw.id === id)!;
        const indexOf = character.weapons.findIndex(cw => cw.id === id);

        weapon.munitionsSpent = (weapon.munitionsSpent + 1) % 4;

        const weapons = character.weapons;

        weapons[indexOf] = weapon;

        props.setCharacter({
            ...character,
            weapons: weapons
        })
    }

    return <>
        <HeadingBar extendBunts>
            <Grid container paddingX={1} alignItems="center" height="100%">
                <Grid item xs={11}>
                    <Grid container>
                        <Grid item xs={7} lineHeight="0em"><HeadingBarItem lineHeight={"1em"}>Name</HeadingBarItem></Grid>
                        <Grid item xs={1} lineHeight="0em"><HeadingBarItem tooltip="Dice" ><DiceIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                        <Grid item xs={1} lineHeight="0em"><HeadingBarItem tooltip="Hit Dice"><HitIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                        <Grid item xs={1} lineHeight="0em"><HeadingBarItem tooltip="Range"><RangeIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                        <Grid item xs={1} lineHeight="0em"><HeadingBarItem tooltip="Endurance Damage"><EnduranceIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                        <Grid item xs={1} lineHeight="0em"><HeadingBarItem tooltip="Crit Damage"><CritDamageIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1} lineHeight="0em"><HeadingBarItem textAlign="center" tooltip="Munitions"><MunitionsIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
            </Grid>
        </HeadingBar>
        <SimpleTable entries={characterDisplay.weapons.map((w, index) => {
            const weapon = character.weapons.find(we => we.id === w.id);
            return <WeaponRow index={index} display={w} weapon={weapon!} onClickMunitions={() => handleMunitions(w.id)} />
        })} />
    </>
}

export default WeaponDisplay